/* Custom: show/hide filter sidebar + filtering without page reload (default collection template) */
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('[id^="shopify-section-template"][id$="__main"]');
  if (!section || !section.querySelector('.content-wrapper > .sidebar')) return;
  var sectionId = section.id.replace('shopify-section-', '');
  var sidebarOpen = /[?&]filter\./.test(location.search);

  function setupToggle() {
    var wrap = section.querySelector('.content-wrapper');
    if (!wrap || !wrap.querySelector(':scope > .sidebar')) return;
    wrap.classList.toggle('sidebar-is-hidden', !sidebarOpen);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sidebar-toggle';
    var label = function () {
      btn.textContent = sidebarOpen ? 'Hide filters' : 'Show filters';
      btn.setAttribute('aria-expanded', sidebarOpen);
    };
    label();
    btn.addEventListener('click', function () {
      sidebarOpen = !sidebarOpen;
      wrap.classList.toggle('sidebar-is-hidden', !sidebarOpen);
      label();
    });
    wrap.parentElement.insertBefore(btn, wrap);
  }

  var controller;
  function render(url, push) {
    if (controller) controller.abort();
    controller = new AbortController();
    var u = new URL(url, location.origin);
    u.searchParams.delete('page');
    var fetchUrl = new URL(u);
    fetchUrl.searchParams.set('section_id', sectionId);
    section.classList.add('is-filtering');
    fetch(fetchUrl, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#' + section.id) || tmp.firstElementChild;
        section.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: { sectionId: sectionId } }));
        section.innerHTML = fresh.innerHTML;
        section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } }));
        setupToggle();
        if (push) history.pushState({ facets: true }, '', u.pathname + u.search);
        section.classList.remove('is-filtering');
      })
      .catch(function (e) { if (e.name !== 'AbortError') location.href = u; });
  }

  function currentSort() {
    var s = section.querySelector('[data-sort-by]');
    return new URLSearchParams(location.search).get('sort_by') || (s && s.value) || '';
  }

  function formUrl(form) {
    var params = new URLSearchParams(new FormData(form));
    var sort = currentSort();
    if (sort) params.set('sort_by', sort);
    return location.pathname + '?' + params.toString();
  }

  // Filter checkboxes and sort dropdown
  section.addEventListener('change', function (e) {
    var t = e.target;
    if (t.closest('[data-faceted-filter-form]') && t.type !== 'number') {
      e.stopImmediatePropagation();
      render(formUrl(t.form), true);
    } else if (t.matches('[data-sort-by]')) {
      e.stopImmediatePropagation();
      var p = new URLSearchParams(location.search);
      p.set('sort_by', t.value);
      render(location.pathname + '?' + p.toString(), true);
    }
  }, true);

  // "Apply" buttons (e.g. price range)
  section.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-faceted-filter-form]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    render(formUrl(e.target), true);
  }, true);

  // Clear all / Clear / remove-filter links
  section.addEventListener('click', function (e) {
    var a = e.target.closest('.sidebar a[href]');
    if (!a) return;
    var u = new URL(a.href, location.origin);
    if (u.pathname !== location.pathname) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    render(u.pathname + u.search, true);
  }, true);

  window.addEventListener('popstate', function () { render(location.href, false); });
  setupToggle();
});